"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
Object.defineProperty(exports, "__esModule", { value: true });
exports.CastSenderEvent = void 0;
exports.CastSenderEvent = {
    AVAILABILITY_CHANGED: "cast:availability_changed",
    CONNECTED: "cast:connected",
    RECONNECTED: "cast:reconnected",
    DISCONNECTED: "cast:disconnected",
    STATE_CHANGE: "cast:state_change",
    METADATA_UPDATE: "cast:metadata_update",
    ERROR: "cast:error",
};
//# sourceMappingURL=cast.js.map